// Access Level Names (from AccessLevel API endpoint)
export const ROLES = {
    SuperAdmin: 'SuperAdmin',
    Admin: 'Admin',
    User: 'User',
    AdminManager: 'AdminManager',
    // IT: 'IT',
    External: 'External'
};

// Azure AD Group to Access Level mapping
// Note: Actual permissions are determined by accessLevelName from user assignment
// AD groups are just for application access
export const ADGroupMapping = {
    "Unite.User": "User",              // Internal users → Role determined by assignment
    "dematic_d_unite": "External",     // External Dev → External role
    "dematic_q_unite": "External",     // External Stage/UAT/QA → External role
    "dematic_p_unite": "External"      // External Prod → External role
};

// Legacy mapping - to be removed once migration is complete
export const RoleMapping = ADGroupMapping;